import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Map, TileLayer, ZoomControl } from 'react-leaflet';

import { handleZoomLevelChanged, handlePositionChanged } from './../../actions/map';
import { resetSelectedSpot } from './../../actions/parkingSpots';
import { MAP_ATTRIBUTION, MAP_URL, MAP_MIN_ZOOM_LEVEL, MAP_MAX_ZOOM_LEVEL, DEFAULT_RACING_TRACK_BOUNDS } from './../../constants';
import ReservedParkingSpotsMarkerList from './ReservedParkingSpotsMarkerList';
import GeoJsonLayer from './GeoJsonLayer';

class MapLayers extends Component {

  constructor(props) {
    super(props);

    this.validGeojsonLayers = this.validGeojsonLayers.bind(this);
    this.onZoomend = this.onZoomend.bind(this);
    this.onViewportChanged = this.onViewportChanged.bind(this);
    this.isIOS = (navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/));
  }

  componentDidMount() {
    this.refs.speedwayMap.leafletElement.setMaxBounds(DEFAULT_RACING_TRACK_BOUNDS);
  }

  onZoomend() {
    this.forceReflowRepaint();
    const zoomLevel = this.refs.speedwayMap.leafletElement.getZoom();
    this.props.handleZoomLevelChanged(zoomLevel);
  }

  forceReflowRepaint() {
    if(this.isIOS){
      const svg = this.refs.speedwayMap.leafletElement._container.querySelector('svg');
      if(svg){
        svg.style.display = 'none';
        svg.offsetHeight;
        svg.style.display = '';
      }
    }
  }

  onViewportChanged(viewport) {
    this.forceReflowRepaint();
    this.props.handlePositionChanged(viewport.center);
  }

  validGeojsonLayers() {
    const {zoomLevel, geoJsonData} = this.props;
    const layersToRender = [];

    Object.keys(geoJsonData).map((entity) => {
      const layers = geoJsonData[entity];

      layers.map((layer, index) => {
        if(layer.minzoom <= zoomLevel &&  zoomLevel <= layer.maxzoom) {
          layersToRender.push(<GeoJsonLayer key={`${entity}-${index}`} data={layer.geojson} entity={entity} zoomLevel={zoomLevel} />);
        }
      });

    });

    return layersToRender;
  }

  render() {
    const { zoomLevel, position } = this.props;

    return (
      <div className="map-leaflet">
        <Map
          center={position}
          zoom={zoomLevel}
          length={4}
          onZoomend={this.onZoomend}
          onViewportChanged={this.onViewportChanged}
          ref="speedwayMap"
          minZoom={MAP_MIN_ZOOM_LEVEL}
          maxZoom={MAP_MAX_ZOOM_LEVEL}
          zoomControl={false}
          preferCanvas={true}
          onClick={() => {this.props.resetSelectedSpot();}}
        >
          <ZoomControl position="bottomright" />
          <TileLayer
            attribution={MAP_ATTRIBUTION}
            url={MAP_URL}
          />

          {this.validGeojsonLayers()}

          <ReservedParkingSpotsMarkerList />

        </Map>
      </div>
    );
  }

}

const mapStateToProps = (state) => (
  {
    zoomLevel: state.map.zoomLevel,
    position: state.map.position,
    geoJsonData: state.geoJsonData
  }
);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ handleZoomLevelChanged, handlePositionChanged, resetSelectedSpot }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MapLayers);



// WEBPACK FOOTER //
// ./src/containers/MapLayers/index.js